import ImportAssets from './importAssets';

export interface IMobxState {
  importAssets: ImportAssets;
}

const web3 = {
  importAssets: new ImportAssets()
};

export default web3;
